import React, { useState, useEffect, Fragment } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  FormGroup,
  Input,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Space_Booking_By_Id,
  API_Ingetration_Channels,
  postAPI_ConfirmSpaceBooking,
  postAPI_RejectSpaceBooking,
  postAPI_CancelSpaceBooking,
} from '../../../../../constants/APIs';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
const bookingStatus = [
  { label: 'On Hold', value: 'OnHold' },
  { label: 'Not Paid', value: 'NotPaid' },
  { label: 'Confirmed', value: 'Confirmed' },
  { label: 'Cancelled', value: 'Cancelled' },
];
function BookingDetail({
  bookingId,
  visible,
  toggle,
  BindData,
  locale,
  propertyId,
}) {
  const [cancelVisible, setCancelVisible] = useState(false);
  const [isBookingRejected, setBookingRejected] = useState(false);
  const [isBookingConfirmed, setBookingConfirmed] = useState(false);
  const [reason, setReason] = useState('');
  const [comments, setComments] = useState('');
  let [integration, setIntegration] = useState();
  const [bookingData, setBookingData] = useState({
    bookingId: '',
    referenceNumber: '',
    checkInDate: '',
    checkOutDate: '',
    adults: null,
    childrens: null,
    roomsUnits: null,
    currency: '',
    amountIncTax: null,
    amountExTax: null,
    comments: '',
    bookingStatus: '',
    paymentStatus: '',
    addOns: [],
    extras: [],
    promos: [],
    roomsRatePlans: [],
    guests: [],
    timeSlot: '',
    spacePriceOptions: [],
  });
  useEffect(() => {
    let body = {
      channels: ['SpaceStandalone'],
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body,
    })
      .then((res) => {
        const spaceStandAloneIntegrationData = res.data.filter(
          (k) =>
            k.channel === 'SpaceStandalone' && k.properties.includes(propertyId)
        );
        if (spaceStandAloneIntegrationData.length > 0)
          setIntegration(spaceStandAloneIntegrationData[0]);
      })
      .catch((err) => {
        console.log(err);
      });

    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Space_Booking_By_Id}/${bookingId}?languageCode=${locale}
`,
    })
      .then((res) => {
        //console.log('res.data', res.data);
        // TODO:
        setBookingData(res.data);
        // setBookingData(DATA);
      })
      .catch((err) => console.log('err', err));
  }, [bookingId]);

  const ConfirmBooking = () => {
    let data = {
      updator: 'dashboard',
      comments: comments,
      contacts:
        integration.spaceStandalonePageIntegration.pageSettings
          .bookingConfirmationSettings === undefined
          ? []
          : integration.spaceStandalonePageIntegration.pageSettings
              .bookingConfirmationSettings.contacts,
    };
    if (
      integration.spaceStandalonePageIntegration.pageSettings
        .bookingConfirmationSettings !== undefined
    )
      data.isSendEmail =
        integration.spaceStandalonePageIntegration.pageSettings
          .bookingConfirmationSettings.emailConfirmation == '1'
          ? false
          : true;
    AxiosAPI({
      method: 'post',
      url: `${postAPI_ConfirmSpaceBooking}/${bookingId}`,
      data: data,
    })
      .then((data) => {
        BindData();
        toggle();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const CancelBooking = () => {
    let data = {
      updator: 'dashboard',
      contacts:
        integration.spaceStandalonePageIntegration.pageSettings
          .bookingConfirmationSettings === undefined
          ? []
          : integration.spaceStandalonePageIntegration.pageSettings
              .bookingConfirmationSettings.contacts,
    };
    if (
      integration.spaceStandalonePageIntegration.pageSettings
        .bookingConfirmationSettings !== undefined
    )
      data.isSendEmail =
        integration.spaceStandalonePageIntegration.pageSettings
          .bookingConfirmationSettings.emailConfirmation === 'SentExternally'
          ? false
          : true;

    AxiosAPI({
      method: 'post',
      url: `${postAPI_CancelSpaceBooking}/${bookingId}`,
      data: data,
    })
      .then((data) => {
        BindData();
        toggle();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const Rejectooking = () => {
    let data = {
      updator: 'dashboard',
      reason: reason,
      contacts:
        integration.spaceStandalonePageIntegration.pageSettings
          .bookingConfirmationSettings === undefined
          ? []
          : integration.spaceStandalonePageIntegration.pageSettings
              .bookingConfirmationSettings.contacts,
    };
    if (
      integration.spaceStandalonePageIntegration.pageSettings
        .bookingConfirmationSettings !== undefined
    )
      data.isSendEmail =
        integration.spaceStandalonePageIntegration.pageSettings
          .bookingConfirmationSettings.emailConfirmation == '1'
          ? false
          : true;
    AxiosAPI({
      method: 'post',
      url: `${postAPI_RejectSpaceBooking}/${bookingId}`,
      data: data,
    })
      .then((data) => {
        BindData();
        toggle();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const toggleCancelBooking = () => {
    setCancelVisible(!cancelVisible);
  };
  console.log(bookingData);
  const generateCancelBooking = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={cancelVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This booking will be cancel!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => CancelBooking()}
                    size="xs"
                  >
                    Cancel Booking
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggleCancelBooking}
                  >
                    Back
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  return (
    <Fragment>
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={visible} toggle={() => toggle()} size="lg">
                <ModalHeader toggle={() => toggle()}>
                  <div>Space Booking Detail</div>
                </ModalHeader>
                <ModalBody>
                  <Row className="mb-3">
                    <Colxx xxs={6}>
                      <Row>
                        <Colxx xxs={6} className="mb-3">
                          <Label>
                            <b>Reference Number</b>
                          </Label>
                          <div>{bookingData.bookingNumber}</div>
                        </Colxx>
                        <Colxx xxs={6} className="mb-3">
                          <Label>
                            <b>Space Name</b>
                          </Label>
                          <div>{bookingData.spaceName}</div>
                        </Colxx>
                        {(bookingData.timeSlot == undefined ||
                          bookingData.timeSlot == null) && (
                          <Fragment>
                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>Check In Date</b>
                              </Label>
                              <div>
                                {moment(bookingData.checkInDate).format('LL')}
                              </div>
                            </Colxx>
                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>Check Out Date</b>
                              </Label>
                              <div>
                                {moment(bookingData.checkOutDate).format('LL')}
                              </div>
                            </Colxx>

                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>Adults</b>
                              </Label>
                              <div>{bookingData.adults}</div>
                            </Colxx>
                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>Childrens</b>
                              </Label>
                              <div>{bookingData.childrens}</div>
                            </Colxx>
                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>No. of Units</b>
                              </Label>
                              <div>{bookingData.roomsUnits}</div>
                            </Colxx>
                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>Base Amount</b>
                              </Label>
                              <div>
                                {bookingData.currency} {bookingData.baseAmount}
                              </div>
                            </Colxx>
                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>Extras</b>
                              </Label>
                              <div>
                                {bookingData.currency}{' '}
                                {bookingData.extrasAmount}
                              </div>
                            </Colxx>
                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>Discount</b>
                              </Label>
                              <div>
                                {bookingData.currency}{' '}
                                {bookingData.discountAmount}
                              </div>
                            </Colxx>
                            <Colxx xxs={12} className="mb-3">
                              <Label>
                                <b>Grand Total</b>
                              </Label>
                              <div>
                                {bookingData.currency} {bookingData.grandTotal}
                              </div>
                            </Colxx>
                          </Fragment>
                        )}
                        {bookingData.timeSlot !== undefined &&
                          bookingData.timeSlot !== null && (
                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>Time Slot</b>
                              </Label>
                              <div>{bookingData.timeSlot}</div>
                            </Colxx>
                          )}
                        {bookingData.timeSlot !== undefined &&
                          bookingData.timeSlot !== null && (
                            <Colxx xxs={6} className="mb-3">
                              <Label>
                                <b>Booking Date</b>
                              </Label>
                              <div>
                                {moment(bookingData.checkInDate).format('LL')}
                              </div>
                            </Colxx>
                          )}
                        <Colxx xxs={12} className="mb-3">
                          <Label>
                            <b>Comments</b>
                          </Label>
                          <div>{bookingData.comments}</div>
                        </Colxx>
                        <Colxx xxs={6} className="mb-3">
                          <Label>
                            <b>Booking Status</b>
                          </Label>
                          <div>
                            {bookingStatus
                              .filter(
                                (k) => k.value === bookingData.bookingStatus
                              )
                              .map((k) => k.label)}
                          </div>
                        </Colxx>
                        <Colxx xxs={6} className="mb-3">
                          <Label>
                            <b>Payment Status</b>
                          </Label>
                          <div>
                            {bookingStatus
                              .filter(
                                (k) => k.value === bookingData.paymentStatus
                              )
                              .map((k) => k.label)}
                          </div>
                        </Colxx>
                        <Colxx xxs={6} className="mb-3">
                          <Label>
                            <b>Parking Space</b>
                          </Label>
                          <div>{bookingData.parkingSpace}</div>
                        </Colxx>
                        <Colxx xxs={6} className="mb-3">
                          <Label>
                            <b>Number Of Attendees</b>
                          </Label>
                          <div>{bookingData.numberOfAttendees}</div>
                        </Colxx>
                        <Colxx xxs={6} className="mb-3">
                          <Label>
                            <b>Preferred Room</b>
                          </Label>
                          <div>{bookingData.preferredRoom}</div>
                        </Colxx>
                      </Row>
                    </Colxx>
                    <Colxx xxs={6}>
                      <Row>
                        <Colxx xxs={12}>
                          <Label>
                            <b>Add-On's</b>
                          </Label>
                          <ul className="ml-2">
                            {bookingData.addOns !== undefined &&
                              bookingData.addOns.length > 0 &&
                              bookingData.addOns.map((addon, i) => (
                                <li className="mb-2">
                                  {getLocalStatement(addon.itemName)}
                                </li>
                              ))}
                          </ul>
                        </Colxx>
                      </Row>
                    </Colxx>
                    <Colxx xxs={6}>
                      <Row>
                        <Colxx xxs={12}>
                          <Label>
                            <b>Space Price Options</b>
                          </Label>
                          {bookingData.spacePriceOptions !== undefined &&
                            bookingData.spacePriceOptions !== null &&
                            bookingData.spacePriceOptions.length > 0 &&
                            bookingData.spacePriceOptions.map((m, i) => (
                              <span className="mb-2">
                                {m.name} {bookingData.currency}
                                {m.price}
                              </span>
                            ))}
                        </Colxx>
                      </Row>
                    </Colxx>
                  </Row>

                  {bookingData.guests != undefined &&
                    bookingData.guests.length > 0 &&
                    bookingData.guests.length > 0 && (
                      <Fragment>
                        <h4>
                          <b>Guest Details</b>
                        </h4>
                        <Row className="mb-3">
                          {(bookingData.timeSlot == undefined ||
                            bookingData.timeSlot == null) && (
                            <Fragment>
                              <Colxx xxs={4} className="mb-3">
                                <Label>
                                  <b>First Name</b>
                                </Label>
                                <div>{bookingData.guests[0].firstName}</div>
                              </Colxx>
                              <Colxx xxs={4} className="mb-3">
                                <Label>
                                  <b>Last Name</b>
                                </Label>
                                <div>{bookingData.guests[0].lastName}</div>
                              </Colxx>
                            </Fragment>
                          )}
                          <Colxx xxs={4} className="mb-3">
                            <Label>
                              <b>Name</b>
                            </Label>
                            <div>{bookingData.guests[0].name}</div>
                          </Colxx>
                          <Colxx xxs={4} className="mb-3">
                            <Label>
                              <b>Email</b>
                            </Label>
                            <div>{bookingData.guests[0].email}</div>
                          </Colxx>
                          <Colxx xxs={4} className="mb-3">
                            <Label>
                              <b>Mobile Number</b>
                            </Label>
                            <div>{bookingData.guests[0].mobileNumber}</div>
                          </Colxx>
                          <Colxx xxs={4} className="mb-3">
                            <Label>
                              <b>Company Name</b>
                            </Label>
                            <div>{bookingData.guests[0].companyName}</div>
                          </Colxx>
                          <Colxx xxs={8} className="mb-3">
                            <Label>
                              <b>Address</b>
                            </Label>
                            <div>
                              {bookingData.guests[0].address}{' '}
                              {bookingData.guests[0].city}{' '}
                              {bookingData.guests[0].state}{' '}
                              {bookingData.guests[0].country}{' '}
                              {bookingData.guests[0].postcode}
                            </div>
                          </Colxx>
                        </Row>
                      </Fragment>
                    )}
                </ModalBody>
                <ModalFooter>
                  {bookingData.bookingStatus !== 'Confirmed' &&
                    bookingData.bookingStatus !== 'Cancelled' && (
                      <Fragment>
                        <Button
                          color="primary"
                          onClick={() =>
                            setBookingConfirmed(!isBookingConfirmed)
                          }
                        >
                          Confirm Booking
                        </Button>
                        <Button
                          color="primary"
                          onClick={() => setBookingRejected(!isBookingRejected)}
                        >
                          Reject Booking
                        </Button>
                      </Fragment>
                    )}

                  {bookingData.bookingStatus === 'Confirmed' && (
                    <Button
                      color="primary"
                      onClick={() => toggleCancelBooking()}
                    >
                      Cancel Booking
                    </Button>
                  )}

                  <Button color="secondary" onClick={() => toggle()}>
                    Cancel
                  </Button>
                </ModalFooter>
                {generateCancelBooking()}
              </Modal>
              <Modal
                isOpen={isBookingRejected}
                size="lg"
                toggle={() => setBookingRejected(!isBookingRejected)}
              >
                <ModalHeader
                  toggle={() => setBookingRejected(!isBookingRejected)}
                >
                  Space Booking Reject
                </ModalHeader>
                <ModalBody>
                  <div className="m-2">
                    <FormGroup>
                      <label>Reason</label>
                      <Input
                        name="reason"
                        onChange={(e) => setReason(e.target.value)}
                        type="textarea"
                        value={reason}
                      />
                    </FormGroup>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Fragment>
                    <Button color="primary" onClick={() => Rejectooking()}>
                      Submit
                    </Button>
                    <Button
                      color="secondary"
                      onClick={() => setBookingRejected(!isBookingRejected)}
                    >
                      Cancel
                    </Button>
                  </Fragment>
                </ModalFooter>
              </Modal>
              <Modal
                isOpen={isBookingConfirmed}
                size="lg"
                toggle={() => setBookingConfirmed(!isBookingConfirmed)}
              >
                <ModalHeader
                  toggle={() => setBookingConfirmed(!isBookingConfirmed)}
                >
                  Space Booking Confirmed
                </ModalHeader>
                <ModalBody>
                  <div className="m-2">
                    <FormGroup>
                      <label>Comments</label>
                      <Input
                        name="comments"
                        onChange={(e) => setComments(e.target.value)}
                        type="textarea"
                        value={comments}
                      />
                    </FormGroup>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Fragment>
                    <Button color="primary" onClick={() => ConfirmBooking()}>
                      Submit
                    </Button>
                    <Button
                      color="secondary"
                      onClick={() => setBookingConfirmed(!isBookingConfirmed)}
                    >
                      Cancel
                    </Button>
                  </Fragment>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(BookingDetail));
